export const DISPLAY_FORMAT = 'YYYY-MM-DD'
export const DB_FORMAT = 'YYYY-MM-DDTHH:mm:ss'
